import clx from "classnames";
import AppIcon from "./AppIcon";

export default function Spinner({ className = "w-4 h-4 text-gray-300" }) {
  return <AppIcon code="spinner" className={clx(className, "animate-spin")} />;
}
